import React from "react";
import UploadIcon from "../../../../../assets/icons/upload";
import useObjectInput from "../../../../../hooks/useObjectInput";

const RenderInputField = ({
  fileTypes,
  fileInputRef,
  handleFileSelect,
  disabled,
  handleDragOver,
  handleDrop,
  handleClick,
  fileOptions,
}) => {
  const { formatBytes } = useObjectInput();

  const handleBrowseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click(); // Programmatically click the hidden file input
    }
  };

  return (
    <div className="goi-field-file">
      <input
        accept={fileTypes}
        ref={fileInputRef}
        type={'file'}
        onChange={handleFileSelect}
        disabled={disabled}
      />
      <div onDragOver={handleDragOver} onDrop={handleDrop}>
        <div className="goi-field-file-upload-wrapper" onClick={handleClick}>
          <div
            className={
              disabled ? "goi-field-file-no-events" : "goi-field-file-events"
            }
          >
            <UploadIcon color={disabled ? "grey" : "black"} />
          </div>
          <div className="goi-field-file-info-wrapper">
            <p>
              <span className="goi-field-file-browse" onClick={(e)=> handleBrowseClick(e)}>Browse</span> or Drag and
              Drop
            </p>
            <p className="goi-field-file-info-inner">
              {fileTypes}
              {(fileOptions.acceptedMaxSize && fileTypes?.length) ? <><span>|</span></> : ""}
              {fileOptions.acceptedMaxSize ? <> max{" "} {formatBytes(fileOptions.acceptedMaxSize)}</> : ""}

            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderInputField;
